export default __webpack_public_path__ + "static/media/bishnu.87119d5c.jpg";